import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { CallState } from '@lcs/shared/api';
import { ReportParameterFormService } from '@ndt/reports/shared/report-parameter-list/services/report-parameter-form.service';
import { Store } from '@ngrx/store';
//import { ReportParameterFormService } from '@qmanage/reports/shared/report-parameter-list/services/report-parameter-form.service';
import { Observable } from 'rxjs';
import { LcsDialogService } from 'src/app/common-components/dialog/dialog.service';
import { PreviewDashboardTile } from '../../models/dashboard-tile.model';
import { TileSet } from '../../tile-set-type-select/models/tile-set.model';
import * as AddDashboardTileActions from '../state/add-dashboard-tile.actions';
import * as AddDashboardTileSelectors from '../state/add-dashboard-tile.selectors';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ndt-add-dashboard-tile',
    templateUrl: './add-dashboard-tile.component.html',
    styleUrls: ['./add-dashboard-tile.component.scss'],
    standalone: false
})
export class AddDashboardTileComponent implements OnInit {
   callState$: Observable<CallState>;

   filteredTileSets$: Observable<TileSet[]>;

   //customTileSet$: Observable<TileSet | null>;

   searchText$: Observable<string | null>;

   constructor(private store: Store, private dialogService: LcsDialogService) {
      this.store.dispatch(AddDashboardTileActions.pageEnter());
   }

   ngOnInit(): void {
      this.callState$ = this.store.select(AddDashboardTileSelectors.selectCallState);
      this.filteredTileSets$ = this.store.select(AddDashboardTileSelectors.selectFilteredTileSets);
      this.searchText$ = this.store.select(AddDashboardTileSelectors.selectSearchText);
   }

   onSearchTextChange(searchText: string): void {
      this.store.dispatch(AddDashboardTileActions.searchTextChange({ searchText }));
   }

   onAddTile(payload: {
      previewTileConfig: PreviewDashboardTile | null;
      formService: ReportParameterFormService<any>;
   }) {
      const { previewTileConfig, formService } = payload;
      if (formService && formService.form.valid) {
         const params = formService.getValue(true);
         this.store.dispatch(
            AddDashboardTileActions.addTile({
               previewTileConfig: previewTileConfig,
               params,
            })
         );
      }
   }

   onCloseClick(): void {
      this.dialogService.close();
   }
}
